import React from "react";

import { Stack } from "@mui/system";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import PaginatedTable from "@src/sharedComponents/Table/PaginatedTable";
import {
  Column,
  Row,
  SophisticatedCell,
} from "@src/sharedComponents/Table/Types";

type TableColumns = "Date" | "Note" | "Author";

const columns: Column<TableColumns>[] = [
  {
    label: "Date",
    accessor: "Date",
    sortable: false,
  },
  {
    label: "Note",
    accessor: "Note",
    sortable: false,
  },
  {
    label: "Author",
    accessor: "Author",
    sortable: false,
  },
];

const loadingRows: Row<TableColumns, SophisticatedCell>[] = Array.from({
  length: 10,
}).map((_, idx) => ({
  key: idx.toString(),
  Date: { value: <Skeleton height={20} width={80} /> },
  Note: {
    value: (
      <Stack direction="row" spacing={1} alignItems="center">
        <Skeleton height={20} width={400} />
      </Stack>
    ),
  },
  Author: {
    value: <Skeleton height={20} width={120} />,
  },
}));

const LoadingState = () => {
  return (
    <PaginatedTable
      key="notes-loading"
      columns={columns}
      rows={loadingRows}
      onPageChange={() => {}}
      pagination={{
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        prevPage: undefined,
        nextPage: undefined,
        totalPages: 0,
      }}
    />
  );
};

export default LoadingState;
